import React from "react";
import { Routes, Route } from "react-router-dom";
import DealersList from "pages/dealers/DealersList";
import DealerDetails from "pages/dealers/DealerDetails";

const DealersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<DealersList />} />
      <Route path=":dealerId" element={<DealerDetails />} />
    </Routes>
  );
};

export default DealersRoutes;
